import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { Decimal, NoValue } from '~/modules/common/components';
import { isNullOrUndefined } from '~/modules/common/util';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap'
  }
}));

const TotalHoursLabel = ({ totalHours }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const hoursSuffix = formatMessage({ id: 'allocationByPeriod.hoursSuffix' });

  return (
    <Typography className={classes.root} component="span">
      <FormattedMessage id="allocationByPeriod.totalLabel" />
      {isNullOrUndefined(totalHours) ? (
        <NoValue />
      ) : (
        <Decimal
          value={totalHours}
          suffix={` ${hoursSuffix}`}
          precision={2}
          fixedDecimalScale
        />
      )}
    </Typography>
  );
};

TotalHoursLabel.propTypes = {
  totalHours: PropTypes.number
};

export default TotalHoursLabel;
